export const commonComponentImages = {
  access_denied: 'assets/new-img/icons/lock.png',
  expand_right_icon: 'assets/img/new-lead-form/expand-right.svg',
  close_square: 'assets/img/close-square.svg',
  plus_solid: 'assets/img/plus-solid.svg',
  share_one: 'assets/img/share-one.svg',
  app_menu_icon: 'assets/img/application-menu.svg',
  down_arrow_icon: 'assets/img/bed-bath/down-arrow.svg',
  up_arrow_icon: 'assets/img/bed-bath/up-arrow.svg',
  eye_view_icon: 'assets/img/bed-bath/Eye.svg',
  eye_close_icon: 'assets/img/bed-bath/Eye-Off.svg',
  remmi_logo: 'assets/headerLogin/Remmi_Logo.svg',
  header_profile: 'assets/headerLogin/profile.png',
  notification_icon: 'assets/img/dashboadIcon/HugeIcon.svg', //'assets/headerLogin/76-notification.svg',
  notes_icon: 'assets/img/dashboadIcon/note.svg', //'assets/headerLogin/note.svg',
  plus_solid_icon: 'assets/headerLogin/plus-solid.svg',
  not_found_icon: 'assets/headerLogin/images-not-found.svg',
  pin_fill_icon: 'assets/headerLogin/pin-fill.svg',
  pin_icon: 'assets/headerLogin/pin.svg',
  voice_icon: 'assets/headerLogin/voice.svg',
  tick_icon: 'assets/new-img/icons/tick-icon.svg',
  mail_share_icon: 'assets/new-img/icons/mail-share.svg',
  id_card_icon: 'assets/img/Peoples_id-card-h.svg',
  huge_icon: 'assets/img/Huge-icon.svg',
  agency_icon: 'assets/img/agency.svg',
  user_icon: 'assets/img/user.svg',
  constructor_icon: 'assets/img/constructor.svg',
  people_upload_icon: 'assets/img/Peoples_people-upload.svg',
  office_icon: 'assets/img/menuIcon/office_icon.svg',
  dashboard_icon: 'assets/img/dashboadIcon/dashboard.svg',
};
